class IconConverter {
    convert(arsoName) {
        switch (arsoName) {
            case 'clear':
                return '0020_clear';
                break;
            case 'clear_day':
                return '0020_clear';
                break;
            case 'clear_night':
                return '0020_clear';
                break;
            case 'clear_lightFG_day':
                return '0019_clear_fog';
                break;
            case 'clear_lightFG_night':
                return '0019_clear_fog';
                break;
            case 'FG':
                return '0013_fog';
                break;
            case 'FG_day':
                return '0013_fog';
                break;
            case 'FG_FG_day':
                return '0013_fog';
                break;
            case 'FG_FG_night':
                return '0013_fog';
                break;
            case 'FG_heavyFG_day':
                return '0013_fog';
                break;
            case 'FG_heavyFG_night':
                return '0013_fog';
                break;
            case 'FG_lightFG_day':
                return '0013_fog';
                break;
            case 'FG_lightFG_night':
                return '0013_fog';
                break;
            case 'FG_modFG_day':
                return '0013_fog';
                break;
            case 'FG_modFG_night':
                return '0013_fog';
                break;
            case 'FG_night':
                return '0013_fog';
                break;
            case 'FG_heavyRASN_day':
                return '0007_rain_snow.svg';
                break;
            case 'FG_heavyRASN_night':
                return '0007_rain_snow.svg';
                break;
            case 'FG_heavySHRASN_day':
                return '0007_rain_snow.svg';
                break;
            case 'FG_heavySHRASN_night':
                return '0007_rain_snow.svg';
                break;
            case 'FG_heavySHSN_day':
                return '0008_snow';
                break;
            case 'FG_heavySHSN_night':
                return '0008_snow';
                break;
            case 'FG_heavySN_day':
                return '0008_snow';
                break;
            case 'FG_heavySN_night':
                return '0008_snow';
                break;
            case 'FG_heavyTS_day':
                return '0003_thunderstorm';
                break;
            case 'FG_heavyTS_night':
                return '0003_thunderstorm';
                break;
            case 'FG_lightTS_day':
                return '0003_thunderstorm';
                break;
            case 'FG_lightTS_night':
                return '0003_thunderstorm';
                break;
            case 'FG_modTS_day':
                return '0003_thunderstorm';
                break;
            case 'FG_modTS_night':
                return '0003_thunderstorm';
                break;
            case 'FG_TS_day':
                return '0003_thunderstorm';
                break;
            case 'FG_TS_night':
                return '0003_thunderstorm';
                break;
            case 'FG_heavyTSGR_day':
                return '0026_hail_storm';
                break;
            case 'FG_heavyTSGR_night':
                return '0026_hail_storm';
                break;
            case 'FG_heavyTSRA_day':
                return '0003_thunderstorm';
                break;
            case 'FG_heavyTSRA_night':
                return '0003_thunderstorm';
                break;
            case 'FG_heavyTSRASN_day':
                return '0022_snow_storm';
                break;
            case 'FG_heavyTSRASN_night':
                return '0022_snow_storm';
                break;
            case 'FG_heavyTSSN_day':
                return '0007_rain_snow';
                break;
            case 'FG_heavyTSSN_night':
                return '0007_rain_snow';
                break;
            case 'FG_heavyDZ_day':
                return '0010_showers';
                break;
            case 'FG_heavyDZ_night':
                return '0010_showers';
                break;
            case 'FG_heavyFZDZ_day':
                return '0010_showers';
                break;
            case 'FG_heavyFZDZ_night':
                return '0010_showers';
                break;
            case 'FG_heavyFZRA_day':
                return '0010_showers';
                break;
            case 'FG_heavyFZRA_night':
                return '0010_showers';
                break;
            case 'FG_heavyRA_day':
                return '0010_showers';
                break;
            case 'FG_heavyRA_night':
                return '0010_showers';
                break;
            case 'FG_heavySHGR_day':
                return '0010_showers';
                break;
            case 'FG_heavySHGR_night':
                return '0010_showers';
                break;
            case 'FG_heavySHRA_day':
                return '0010_showers';
                break;
            case 'FG_heavySHRA_night':
                return '0010_showers';
                break;
            case 'FG_lightRASN_day':
                return '0021_flurries';
                break;
            case 'FG_lightRASN_night':
                return '0021_flurries';
                break;
            case 'FG_lightSHRASN_day':
                return '0021_flurries';
                break;
            case 'FG_lightSHRASN_night':
                return '0021_flurries';
                break;
            case 'FG_lightSHSN_day':
                return '0008_snow';
                break;
            case 'FG_lightSHSN_night':
                return '0008_snow';
                break;
            case 'FG_lightSN_day':
                return '0008_snow';
                break;
            case 'FG_lightSN_night':
                return '0008_snow';
                break;
            case 'FG_lightTSGR_day':
                return '0026_hail_storm';
                break;
            case 'FG_lightTSGR_night':
                return '0026_hail_storm';
                break;
            case 'FG_lightTSRA_day':
                return '0003_thunderstorm';
                break;
            case 'FG_lightTSRA_night':
                return '0003_thunderstorm';
                break;
            case 'FG_lightTSRASN_day':
                return '0022_snow_storm';
                break;
            case 'FG_lightTSRASN_night':
                return '0022_snow_storm';
                break;
            case 'FG_lightTSSN_day':
                return '0022_snow_storm';
                break;
            case 'FG_lightTSSN_night':
                return '0022_snow_storm';
                break;
            case 'FG_lightDZ_day':
                return '0011_showers_light';
                break;
            case 'FG_lightDZ_night':
                return '0011_showers_light';
                break;
            case 'FG_lightFZDZ_day':
                return '0011_showers_light';
                break;
            case 'FG_lightFZDZ_night':
                return '0011_showers_light';
                break;
            case 'FG_lightFZRA_day':
                return '0011_showers_light';
                break;
            case 'FG_lightFZRA_night':
                return '0011_showers_light';
                break;
            case 'FG_lightRA_day':
                return '0011_showers_light';
                break;
            case 'FG_lightRA_night':
                return '0011_showers_light';
                break;
            case 'FG_lightSHGR_day':
                return '0011_showers_light';
                break;
            case 'FG_lightSHGR_night':
                return '0011_showers_light';
                break;
            case 'FG_lightSHRA_day':
                return '0011_showers_light';
                break;
            case 'FG_lightSHRA_night':
                return '0011_showers_light';
                break;
            case 'FG_DZ_day':
                return '0012_showers_light_2';
                break;
            case 'FG_DZ_night':
                return '0012_showers_light_2';
                break;
            case 'FG_FZDZ_day':
                return '0012_showers_light_2';
                break;
            case 'FG_FZDZ_night':
                return '0012_showers_light_2';
                break;
            case 'FG_FZRA_day':
                return '0012_showers_light_2';
                break;
            case 'FG_FZRA_night':
                return '0012_showers_light_2';
                break;
            case 'FG_modDZ_day':
                return '0012_showers_light_2';
                break;
            case 'FG_modDZ_night':
                return '0012_showers_light_2';
                break;
            case 'FG_modFZDZ_day':
                return '0012_showers_light_2';
                break;
            case 'FG_modFZDZ_night':
                return '0012_showers_light_2';
                break;
            case 'FG_modFZRA_day':
                return '0012_showers_light_2';
                break;
            case 'FG_modFZRA_night':
                return '0012_showers_light_2';
                break;
            case 'FG_modRA_day':
                return '0012_showers_light_2';
                break;
            case 'FG_modRA_night':
                return '0012_showers_light_2';
                break;
            case 'FG_modSHGR_day':
                return '0012_showers_light_2';
                break;
            case 'FG_modSHGR_night':
                return '0012_showers_light_2';
                break;
            case 'FG_modSHRA_day':
                return '0012_showers_light_2';
                break;
            case 'FG_modSHRA_night':
                return '0012_showers_light_2';
                break;
            case 'FG_RA_day':
                return '0012_showers_light_2';
                break;
            case 'FG_RA_night':
                return '0012_showers_light_2';
                break;
            case 'FG_SHGR_day':
                return '0012_showers_light_2';
                break;
            case 'FG_SHGR_night':
                return '0012_showers_light_2';
                break;
            case 'FG_SHRA_day':
                return '0012_showers_light_2';
                break;
            case 'FG_SHRA_night':
                return '0012_showers_light_2';
                break;
            case 'FG_modRASN_day':
                return '0007_rain_snow';
                break;
            case 'FG_modRASN_night':
                return '0007_rain_snow';
                break;
            case 'FG_modSHRASN_day':
                return '0007_rain_snow';
                break;
            case 'FG_modSHRASN_night':
                return '0007_rain_snow';
                break;
            case 'FG_RASN_day':
                return '0007_rain_snow';
                break;
            case 'FG_RASN_night':
                return '0007_rain_snow';
                break;
            case 'FG_SHRASN_day':
                return '0007_rain_snow';
                break;
            case 'FG_SHRASN_night':
                return '0007_rain_snow';
                break;
            case 'FG_modSHSN_day':
                return '0008_snow';
                break;
            case 'FG_modSHSN_night':
                return '0008_snow';
                break;
            case 'FG_modSN_day':
                return '0008_snow';
                break;
            case 'FG_modSN_night':
                return '0008_snow';
                break;
            case 'FG_SHSN_day':
                return '0008_snow';
                break;
            case 'FG_SHSN_night':
                return '0008_snow';
                break;
            case 'FG_SN_day':
                return '0008_snow';
                break;
            case 'FG_SN_night':
                return '0008_snow';
                break;
            case 'FG_modTSRASN_day':
                return '0022_snow_storm';
                break;
            case 'FG_modTSRASN_night':
                return '0022_snow_storm';
                break;
            case 'FG_TSRASN_day':
                return '0022_snow_storm';
                break;
            case 'FG_TSRASN_night':
                return '0022_snow_storm';
                break;
            case 'FG_modTSSN_day':
                return '0022_snow_storm';
                break;
            case 'FG_modTSSN_night':
                return '0022_snow_storm';
                break;
            case 'FG_TSSN_day':
                return '0022_snow_storm';
                break;
            case 'FG_TSSN_night':
                return '0022_snow_storm';
                break;
            case 'FG_modTSGR_day':
                return '0026_hail_storm';
                break;
            case 'FG_modTSGR_night':
                return '0026_hail_storm';
                break;
            case 'FG_TSGR_day':
                return '0026_hail_storm';
                break;
            case 'FG_TSGR_night':
                return '0026_hail_storm';
                break;
            case 'FG_modTSRA_day':
                return '0003_thunderstorm';
                break;
            case 'FG_modTSRA_night':
                return '0003_thunderstorm';
                break;
            case 'FG_TSRA_day':
                return '0003_thunderstorm';
                break;
            case 'FG_TSRA_night':
                return '0003_thunderstorm';
                break;
            case 'heavyDZ':
                return '0009_showers_2';
                break;
            case 'heavyFZDZ':
                return '0009_showers_2';
                break;
            case 'heavyFZRA':
                return '0009_showers_2';
                break;
            case 'heavyRA':
                return '0009_showers_2';
                break;
            case 'heavySHGR':
                return '0009_showers_2';
                break;
            case 'heavySHRA':
                return '0009_showers_2';
                break;
            case 'heavyFG':
                return '0013_fog';
                break;
            case 'heavyRASN':
                return '0007_rain_snow';
                break;
            case 'heavySHRASN':
                return '0007_rain_snow';
                break;
            case 'heavySHSN':
                return '0008_snow';
                break;
            case 'heavySN':
                return '0008_snow';
                break;
            case 'heavyTSGR':
                return '0026_hail_storm';
                break;
            case 'heavyTSRA':
                return '0003_thunderstorm';
                break;
            case 'heavyTSRASN':
                return '0022_snow_storm';
                break;
            case 'heavyTSSN':
                return '0022_snow_storm';
                break;
            case 'lightDZ':
                return '0011_showers_light';
                break;
            case 'lightFZDZ':
                return '0011_showers_light';
                break;
            case 'lightFZRA':
                return '0011_showers_light';
                break;
            case 'lightRA':
                return '0011_showers_light';
                break;
            case 'lightSHGR':
                return '0011_showers_light';
                break;
            case 'lightSHRA':
                return '0011_showers_light';
                break;
            case 'lightFG':
                return '0013_fog';
                break;
            case 'lightFG_day':
                return '0013_fog';
                break;
            case 'lightFG_night':
                return '0013_fog';
                break;
            case 'lightRASN':
                return '0021_flurries';
                break;
            case 'lightSHRASN':
                return '0021_flurries';
                break;
            case 'lightSHSN':
                return '0008_snow';
                break;
            case 'lightSN':
                return '0008_snow';
                break;
            case 'lightTSGR':
                return '0026_hail_storm';
                break;
            case 'lightTSRA':
                return '0003_thunderstorm';
                break;
            case 'lightTSRASN':
                return '0023_rain_snow_storm';
                break;
            case 'lightTSSN':
                return '0003_thunderstorm';
                break;
            case 'DZ':
                return '0012_showers_light_2';
                break;
            case 'FZDZ':
                return '0012_showers_light_2';
                break;
            case 'FZRA':
                return '0012_showers_light_2';
                break;
            case 'modDZ':
                return '0012_showers_light_2';
                break;
            case 'modFZDZ':
                return '0012_showers_light_2';
                break;
            case 'modFZRA':
                return '0012_showers_light_2';
                break;
            case 'modRA':
                return '0012_showers_light_2';
                break;
            case 'modSHGR':
                return '0012_showers_light_2';
                break;
            case 'modSHRA':
                return '0012_showers_light_2';
                break;
            case 'RA':
                return '0012_showers_light_2';
                break;
            case 'SHGR':
                return '0012_showers_light_2';
                break;
            case 'SHRA':
                return '0012_showers_light_2';
                break;
            case 'modFG':
                return '0013_fog';
                break;
            case 'modRASN':
                return '0007_rain_snow';
                break;
            case 'modSHRASN':
                return '0007_rain_snow';
                break;
            case 'RASN':
                return '0007_rain_snow';
                break;
            case 'SHRASN':
                return '0007_rain_snow';
                break;
            case 'modSHSN':
                return '0008_snow';
                break;
            case 'modSN':
                return '0008_snow';
                break;
            case 'SHSN':
                return '0008_snow';
                break;
            case 'SN':
                return '0008_snow';
                break;
            case 'overcast':
                return '0017_cloudy';
                break;
            case 'overcast_day':
                return '0017_cloudy';
                break;
            case 'overcast_night':
                return '0017_cloudy';
                break;
            case 'overcast_heavyFG_day':
                return '0028_fog_cloudy';
                break;
            case 'overcast_heavyFG_night':
                return '0028_fog_cloudy';
                break;
            case 'overcast_heavyRASN_day':
                return '0007_rain_snow';
                break;
            case 'overcast_heavyRASN_night':
                return '0007_rain_snow';
                break;
            case 'overcast_heavySHRASN_day':
                return '0007_rain_snow';
                break;
            case 'overcast_heavySHRASN_night':
                return '0007_rain_snow';
                break;
            case 'overcast_heavyTSGR_day':
                return '0026_hail_storm';
                break;
            case 'overcast_heavyTSGR_night':
                return '0026_hail_storm';
                break;
            case 'overcast_heavyTSRA_day':
                return '0003_thunderstorm';
                break;
            case 'overcast_heavyTSRA_night':
                return '0003_thunderstorm';
                break;
            case 'overcast_heavyTSRASN_day':
                return '0023_rain_snow_storm';
                break;
            case 'overcast_heavyTSRASN_night':
                return '0023_rain_snow_storm';
                break;
            case 'overcast_heavyTSSN_day':
                return '0022_snow_storm';
                break;
            case 'overcast_heavyTSSN_night':
                return '0022_snow_storm';
                break;
            case 'overcast_heavyDZ_day':
                return '0009_showers_2';
                break;
            case 'overcast_heavyDZ_night':
                return '0009_showers_2';
                break;
            case 'overcast_heavyFZDZ_day':
                return '0009_showers_2';
                break;
            case 'overcast_heavyFZDZ_night':
                return '0009_showers_2';
                break;
            case 'overcast_heavyFZRA_day':
                return '0009_showers_2';
                break;
            case 'overcast_heavyFZRA_night':
                return '0009_showers_2';
                break;
            case 'overcast_heavyRA_day':
                return '0009_showers_2';
                break;
            case 'overcast_heavyRA_night':
                return '0009_showers_2';
                break;
            case 'overcast_heavySHGR_day':
                return '0009_showers_2';
                break;
            case 'overcast_heavySHGR_night':
                return '0009_showers_2';
                break;
            case 'overcast_heavySHRA_day':
                return '0009_showers_2';
                break;
            case 'overcast_heavySHRA_night':
                return '0009_showers_2';
                break;
            case 'overcast_heavySHSN_day':
                return '0008_snow';
                break;
            case 'overcast_heavySHSN_night':
                return '0008_snow';
                break;
            case 'overcast_heavySN_day':
                return '0008_snow';
                break;
            case 'overcast_heavySN_night':
                return '0008_snow';
                break;
            case 'overcast_modFG_night':
                return '0008_snow';
                break;
            case 'overcast_lightFG_night':
                return '0028_fog_cloudy';
                break;
            case 'overcast_lightTSGR_day':
                return '0026_hail_storm';
                break;
            case 'overcast_lightTSGR_night':
                return '0026_hail_storm';
                break;
            case 'overcast_lightTSRA_day':
                return '0003_thunderstorm';
                break;
            case 'overcast_lightTSRA_night':
                return '0003_thunderstorm';
                break;
            case 'overcast_lightTSRASN_day':
                return '0023_rain_snow_storm';
                break;
            case 'overcast_lightTSRASN_night':
                return '0023_rain_snow_storm';
                break;
            case 'overcast_lightTSSN_day':
                return '0022_snow_storm';
                break;
            case 'overcast_lightTSSN_night':
                return '0022_snow_storm';
                break;
            case 'overcast_lightDZ_day':
                return '0011_showers_light';
                break;
            case 'overcast_lightDZ_night':
                return '0011_showers_light';
                break;
            case 'overcast_lightFZDZ_day':
                return '0011_showers_light';
                break;
            case 'overcast_lightFZDZ_night':
                return '0011_showers_light';
                break;
            case 'overcast_lightFZRA_day':
                return '0011_showers_light';
                break;
            case 'overcast_lightFZRA_night':
                return '0011_showers_light';
                break;
            case 'overcast_lightRA_day':
                return '0011_showers_light';
                break;
            case 'overcast_lightRA_night':
                return '0011_showers_light';
                break;
            case 'overcast_lightSHGR_day':
                return '0011_showers_light';
                break;
            case 'overcast_lightSHGR_night':
                return '0011_showers_light';
                break;
            case 'overcast_lightSHRA_day':
                return '0011_showers_light';
                break;
            case 'overcast_lightSHRA_night':
                return '0011_showers_light';
                break;
            case 'overcast_lightRASN_day':
                return '0021_flurries';
                break;
            case 'overcast_lightRASN_night':
                return '0021_flurries';
                break;
            case 'overcast_lightSHRASN_day':
                return '0021_flurries';
                break;
            case 'overcast_lightSHRASN_night':
                return '0021_flurries';
                break;
            case 'overcast_lightSHSN_day':
                return '0008_snow';
                break;
            case 'overcast_lightSHSN_night':
                return '0008_snow';
                break;
            case 'overcast_lightSN_day':
                return '0008_snow';
                break;
            case 'overcast_lightSN_night':
                return '0008_snow';
                break;
            case 'overcast_heavyTS_day':
                return '0003_thunderstorm';
                break;
            case 'overcast_heavyTS_night':
                return '0003_thunderstorm';
                break;
            case 'overcast_lightTS_day':
                return '0003_thunderstorm';
                break;
            case 'overcast_lightTS_night':
                return '0003_thunderstorm';
                break;
            case 'overcast_modTS_day':
                return '0003_thunderstorm';
                break;
            case 'overcast_modTS_night':
                return '0003_thunderstorm';
                break;
            case 'overcast_TS_day':
                return '0003_thunderstorm';
                break;
            case 'overcast_TS_night':
                return '0003_thunderstorm';
                break;
            case 'overcast_FG_day':
                return '0028_fog_cloudy';
                break;
            case 'overcast_FG_night':
                return '0028_fog_cloudy';
                break;
            case 'overcast_lightFG_day':
                return '0028_fog_cloudy';
                break;
            case 'overcast_modFG_day':
                return '0028_fog_cloudy';
                break;
            case 'overcast_modTSGR_day':
                return '0026_hail_storm';
                break;
            case 'overcast_modTSGR_night':
                return '0026_hail_storm';
                break;
            case 'overcast_TSGR_day':
                return '0026_hail_storm';
                break;
            case 'overcast_TSGR_night':
                return '0026_hail_storm';
                break;
            case 'overcast_modTSRA_day':
                return '0003_thunderstorm';
                break;
            case 'overcast_modTSRA_night':
                return '0003_thunderstorm';
                break;
            case 'overcast_TSRA_day':
                return '0003_thunderstorm';
                break;
            case 'overcast_TSRA_night':
                return '0003_thunderstorm';
                break;
            case 'overcast_modTSRASN_day':
                return '0023_rain_snow_storm';
                break;
            case 'overcast_modTSRASN_night':
                return '0023_rain_snow_storm';
                break;
            case 'overcast_TSRASN_day':
                return '0023_rain_snow_storm';
                break;
            case 'overcast_TSRASN_night':
                return '0023_rain_snow_storm';
                break;
            case 'overcast_modTSSN_day':
                return '0022_snow_storm';
                break;
            case 'overcast_modTSSN_night':
                return '0022_snow_storm';
                break;
            case 'overcast_TSSN_day':
                return '0022_snow_storm';
                break;
            case 'overcast_TSSN_night':
                return '0022_snow_storm';
                break;
            case 'overcast_DZ_day':
                return '0012_showers_light_2';
                break;
            case 'overcast_DZ_night':
                return '0012_showers_light_2';
                break;
            case 'overcast_FZDZ_day':
                return '0012_showers_light_2';
                break;
            case 'overcast_FZDZ_night':
                return '0012_showers_light_2';
                break;
            case 'overcast_FZRA_day':
                return '0012_showers_light_2';
                break;
            case 'overcast_FZRA_night':
                return '0012_showers_light_2';
                break;
            case 'overcast_modDZ_day':
                return '0012_showers_light_2';
                break;
            case 'overcast_modDZ_night':
                return '0012_showers_light_2';
                break;
            case 'overcast_modFZDZ_day':
                return '0012_showers_light_2';
                break;
            case 'overcast_modFZDZ_night':
                return '0012_showers_light_2';
                break;
            case 'overcast_modFZRA_day':
                return '0012_showers_light_2';
                break;
            case 'overcast_modFZRA_night':
                return '0012_showers_light_2';
                break;
            case 'overcast_modRA_day':
                return '0012_showers_light_2';
                break;
            case 'overcast_modRA_night':
                return '0012_showers_light_2';
                break;
            case 'overcast_modSHGR_day':
                return '0012_showers_light_2';
                break;
            case 'overcast_modSHGR_night':
                return '0012_showers_light_2';
                break;
            case 'overcast_modSHRA_day':
                return '0012_showers_light_2';
                break;
            case 'overcast_modSHRA_night':
                return '0012_showers_light_2';
                break;
            case 'overcast_RA_day':
                return '0012_showers_light_2';
                break;
            case 'overcast_RA_night':
                return '0012_showers_light_2';
                break;
            case 'overcast_SHGR_day':
                return '0012_showers_light_2';
                break;
            case 'overcast_SHGR_night':
                return '0012_showers_light_2';
                break;
            case 'overcast_SHRA_day':
                return '0012_showers_light_2';
                break;
            case 'overcast_SHRA_night':
                return '0012_showers_light_2';
                break;
            case 'overcast_modRASN_day':
                return '0007_rain_snow';
                break;
            case 'overcast_modRASN_night':
                return '0007_rain_snow';
                break;
            case 'overcast_modSHRASN_day':
                return '0007_rain_snow';
                break;
            case 'overcast_modSHRASN_night':
                return '0007_rain_snow';
                break;
            case 'overcast_RASN_day':
                return '0007_rain_snow';
                break;
            case 'overcast_RASN_night':
                return '0007_rain_snow';
                break;
            case 'overcast_SHRASN_day':
                return '0007_rain_snow';
                break;
            case 'overcast_SHRASN_night':
                return '0007_rain_snow';
                break;
            case 'overcast_modSHSN_day':
                return '0008_snow';
                break;
            case 'overcast_modSHSN_night':
                return '0008_snow';
                break;
            case 'overcast_modSN_day':
                return '0008_snow';
                break;
            case 'overcast_modSN_night':
                return '0008_snow';
                break;
            case 'overcast_SHSN_day':
                return '0008_snow';
                break;
            case 'overcast_SHSN_night':
                return '0008_snow';
                break;
            case 'overcast_SN_day':
                return '0008_snow';
                break;
            case 'overcast_SN_night':
                return '0008_snow';
                break;
            case 'partCloudy':
                return '0015_clear_cloudy_prev';
                break;
            case 'partCloudy_day':
                return '0015_clear_cloudy_prev';
                break;
            case 'partCloudy_night':
                return '0015_clear_cloudy_prev';
                break;
            case 'partCloudy_FG_day':
                return '0018_clear_fog_cloudy';
                break;
            case 'partCloudy_FG_night':
                return '0018_clear_fog_cloudy';
                break;
            case 'partCloudy_heavyFG_day':
                return '0018_clear_fog_cloudy';
                break;
            case 'partCloudy_heavyFG_night':
                return '0018_clear_fog_cloudy';
                break;
            case 'partCloudy_modFG_day':
                return '0018_clear_fog_cloudy';
                break;
            case 'partCloudy_modFG_night':
                return '0018_clear_fog_cloudy';
                break;
            case 'partCloudy_heavyDZ_day':
                return '0005_clear_showers';
                break;
            case 'partCloudy_heavyDZ_night':
                return '0005_clear_showers';
                break;
            case 'partCloudy_heavyFZDZ_day':
                return '0005_clear_showers';
                break;
            case 'partCloudy_heavyFZDZ_night':
                return '0005_clear_showers';
                break;
            case 'partCloudy_heavyFZRA_day':
                return '0005_clear_showers';
                break;
            case 'partCloudy_heavyFZRA_night':
                return '0005_clear_showers';
                break;
            case 'partCloudy_heavyRA_day':
                return '0005_clear_showers';
                break;
            case 'partCloudy_heavyRA_night':
                return '0005_clear_showers';
                break;
            case 'partCloudy_heavySHGR_day':
                return '0005_clear_showers';
                break;
            case 'partCloudy_heavySHGR_night':
                return '0005_clear_showers';
                break;
            case 'partCloudy_heavySHRA_day':
                return '0005_clear_showers';
                break;
            case 'partCloudy_heavySHRA_night':
                return '0005_clear_showers';
                break;
            case 'partCloudy_heavyRASN_day':
                return '0006_sun_rain_snow';
                break;
            case 'partCloudy_heavyRASN_night':
                return '0006_sun_rain_snow';
                break;
            case 'partCloudy_heavySHRASN_day':
                return '0006_sun_rain_snow';
                break;
            case 'partCloudy_heavySHRASN_night':
                return '0006_sun_rain_snow';
                break;
            case 'partCloudy_heavySHSN_day':
                return '0004_clear_snow';
                break;
            case 'partCloudy_heavySHSN_night':
                return '0004_clear_snow';
                break;
            case 'partCloudy_heavySN_day':
                return '0004_clear_snow';
                break;
            case 'partCloudy_heavySN_night':
                return '0004_clear_snow';
                break;
            case 'partCloudy_heavyTS_day':
                return '0002_sun_thunderstorm';
                break;
            case 'partCloudy_heavyTS_night':
                return '0002_sun_thunderstorm';
                break;
            case 'partCloudy_lightTS_day':
                return '0002_sun_thunderstorm';
                break;
            case 'partCloudy_lightTS_night':
                return '0002_sun_thunderstorm';
                break;
            case 'partCloudy_modTS_day':
                return '0002_sun_thunderstorm';
                break;
            case 'partCloudy_modTS_night':
                return '0002_sun_thunderstorm';
                break;
            case 'partCloudy_TS_day':
                return '0002_sun_thunderstorm';
                break;
            case 'partCloudy_TS_night':
                return '0002_sun_thunderstorm';
                break;
            case 'partCloudy_heavyTSGR_day':
                return '0027_sun_hail_storm';
                break;
            case 'partCloudy_heavyTSGR_night':
                return '0027_sun_hail_storm';
                break;
            case 'partCloudy_heavyTSRASN_day':
                return '0002_sun_thunderstorm';
                break;
            case 'partCloudy_heavyTSRASN_night':
                return '0002_sun_thunderstorm';
                break;
            case 'partCloudy_heavyTSRA_day':
                return '0002_sun_thunderstorm';
                break;
            case 'partCloudy_heavyTSRA_night':
                return '0002_sun_thunderstorm';
                break;
            case 'partCloudy_heavyTSSN_day':
                return '0002_sun_thunderstorm';
                break;
            case 'partCloudy_heavyTSSN_night':
                return '0002_sun_thunderstorm';
                break;
            case 'partCloudy_lightDZ_day':
                return '0005_clear_showers';
                break;
            case 'partCloudy_lightDZ_night':
                return '0005_clear_showers';
                break;
            case 'partCloudy_lightFZDZ_day':
                return '0005_clear_showers';
                break;
            case 'partCloudy_lightFZDZ_night':
                return '0005_clear_showers';
                break;
            case 'partCloudy_lightFZRA_day':
                return '0005_clear_showers';
                break;
            case 'partCloudy_lightFZRA_night':
                return '0005_clear_showers';
                break;
            case 'partCloudy_lightRA_day':
                return '0005_clear_showers';
                break;
            case 'partCloudy_lightRA_night':
                return '0005_clear_showers';
                break;
            case 'partCloudy_lightSHGR_day':
                return '0005_clear_showers';
                break;
            case 'partCloudy_lightSHGR_night':
                return '0005_clear_showers';
                break;
            case 'partCloudy_lightSHRA_day':
                return '0005_clear_showers';
                break;
            case 'partCloudy_lightSHRA_night':
                return '0005_clear_showers';
                break;
            case 'partCloudy_lightFG_day':
                return '0018_clear_fog_cloudy';
                break;
            case 'partCloudy_lightFG_night':
                return '0018_clear_fog_cloudy';
                break;
            case 'partCloudy_lightRASN_day':
                return '0006_sun_rain_snow';
                break;
            case 'partCloudy_lightRASN_night':
                return '0006_sun_rain_snow';
                break;
            case 'partCloudy_lightSHRASN_day':
                return '0006_sun_rain_snow';
                break;
            case 'partCloudy_lightSHRASN_night':
                return '0006_sun_rain_snow';
                break;
            case 'partCloudy_lightSHSN_day':
                return '0004_clear_snow';
                break;
            case 'partCloudy_lightSHSN_night':
                return '0004_clear_snow';
                break;
            case 'partCloudy_lightSN_day':
                return '0004_clear_snow';
                break;
            case 'partCloudy_lightSN_night':
                return '0004_clear_snow';
                break;
            case 'partCloudy_lightTSGR_day':
                return '0027_sun_hail_storm';
                break;
            case 'partCloudy_lightTSGR_night':
                return '0027_sun_hail_storm';
                break;
            case 'partCloudy_lightTSRA_day':
                return '0002_sun_thunderstorm';
                break;
            case 'partCloudy_lightTSRA_night':
                return '0002_sun_thunderstorm';
                break;
            case 'partCloudy_lightTSRASN_day':
                return '0006_sun_rain_snow';
                break;
            case 'partCloudy_lightTSRASN_night':
                return '0006_sun_rain_snow';
                break;
            case 'partCloudy_lightTSSN_day':
                return '0004_clear_snow';
                break;
            case 'partCloudy_lightTSSN_night':
                return '0004_clear_snow';
                break;
            case 'partCloudy_DZ_day':
                return '0005_clear_showers';
                break;
            case 'partCloudy_DZ_night':
                return '0005_clear_showers';
                break;
            case 'partCloudy_FZDZ_day':
                return '0005_clear_showers';
                break;
            case 'partCloudy_FZDZ_night':
                return '0005_clear_showers';
                break;
            case 'partCloudy_FZRA_day':
                return '0005_clear_showers';
                break;
            case 'partCloudy_FZRA_night':
                return '0005_clear_showers';
                break;
            case 'partCloudy_modDZ_day':
                return '0005_clear_showers';
                break;
            case 'partCloudy_modDZ_night':
                return '0005_clear_showers';
                break;
            case 'partCloudy_modFZDZ_day':
                return '0005_clear_showers';
                break;
            case 'partCloudy_modFZDZ_night':
                return '0005_clear_showers';
                break;
            case 'partCloudy_modFZRA_day':
                return '0005_clear_showers';
                break;
            case 'partCloudy_modFZRA_night':
                return '0005_clear_showers';
                break;
            case 'partCloudy_modRA_day':
                return '0005_clear_showers';
                break;
            case 'partCloudy_modRA_night':
                return '0005_clear_showers';
                break;
            case 'partCloudy_modSHGR_day':
                return '0005_clear_showers';
                break;
            case 'partCloudy_modSHGR_night':
                return '0005_clear_showers';
                break;
            case 'partCloudy_modSHRA_day':
                return '0005_clear_showers';
                break;
            case 'partCloudy_modSHRA_night':
                return '0005_clear_showers';
                break;
            case 'partCloudy_RA_day':
                return '0005_clear_showers';
                break;
            case 'partCloudy_RA_night':
                return '0005_clear_showers';
                break;
            case 'partCloudy_SHGR_day':
                return '0005_clear_showers';
                break;
            case 'partCloudy_SHGR_night':
                return '0005_clear_showers';
                break;
            case 'partCloudy_SHRA_day':
                return '0005_clear_showers';
                break;
            case 'partCloudy_SHRA_night':
                return '0005_clear_showers';
                break;
            case 'partCloudy_modRASN_day':
                return '0006_sun_rain_snow';
                break;
            case 'partCloudy_modRASN_night':
                return '0006_sun_rain_snow';
                break;
            case 'partCloudy_modSHRASN_day':
                return '0006_sun_rain_snow';
                break;
            case 'partCloudy_modSHRASN_night':
                return '0006_sun_rain_snow';
                break;
            case 'partCloudy_RASN_day':
                return '0006_sun_rain_snow';
                break;
            case 'partCloudy_RASN_night':
                return '0006_sun_rain_snow';
                break;
            case 'partCloudy_SHRASN_day':
                return '0006_sun_rain_snow';
                break;
            case 'partCloudy_SHRASN_night':
                return '0006_sun_rain_snow';
                break;
            case 'partCloudy_modSHSN_day':
                return '0004_clear_snow';
                break;
            case 'partCloudy_modSHSN_night':
                return '0004_clear_snow';
                break;
            case 'partCloudy_modSN_day':
                return '0004_clear_snow';
                break;
            case 'partCloudy_modSN_night':
                return '0004_clear_snow';
                break;
            case 'partCloudy_SHSN_day':
                return '0004_clear_snow';
                break;
            case 'partCloudy_SHSN_night':
                return '0004_clear_snow';
                break;
            case 'partCloudy_SN_day':
                return '0004_clear_snow';
                break;
            case 'partCloudy_SN_night':
                return '0004_clear_snow';
                break;
            case 'partCloudy_modTSGR_day':
                return '0027_sun_hail_storm';
                break;
            case 'partCloudy_modTSGR_night':
                return '0027_sun_hail_storm';
                break;
            case 'partCloudy_TSGR_day':
                return '0027_sun_hail_storm';
                break;
            case 'partCloudy_TSGR_night':
                return '0027_sun_hail_storm';
                break;
            case 'partCloudy_modTSRASN_day':
                return '0006_sun_rain_snow';
                break;
            case 'partCloudy_modTSRASN_night':
                return '0006_sun_rain_snow';
                break;
            case 'partCloudy_TSRASN_day':
                return '0006_sun_rain_snow';
                break;
            case 'partCloudy_TSRASN_night':
                return '0006_sun_rain_snow';
                break;
            case 'partCloudy_modTSSN_day':
                return '0004_clear_snow';
                break;
            case 'partCloudy_modTSSN_night':
                return '0004_clear_snow';
                break;
            case 'partCloudy_TSSN_day':
                return '0004_clear_snow';
                break;
            case 'partCloudy_TSSN_night':
                return '0004_clear_snow';
                break;
            case 'partCloudy_modTSRA_day':
                return '0002_sun_thunderstorm';
                break;
            case 'partCloudy_modTSRA_night':
                return '0002_sun_thunderstorm';
                break;
            case 'partCloudy_TSRA_day':
                return '0002_sun_thunderstorm';
                break;
            case 'partCloudy_TSRA_night':
                return '0002_sun_thunderstorm';
                break;
            case 'prevCloudy':
                return '0014_clear_cloudy_mod';
                break;
            case 'prevCloudy_day':
                return '0014_clear_cloudy_mod';
                break;
            case 'prevCloudy_night':
                return '0014_clear_cloudy_mod';
                break;
            case 'prevCloudy_FG_day':
                return '0018_clear_fog_cloudy';
                break;
            case 'prevCloudy_FG_night':
                return '0018_clear_fog_cloudy';
                break;
            case 'prevCloudy_modFG_day':
                return '0018_clear_fog_cloudy';
                break;
            case 'prevCloudy_modFG_night':
                return '0018_clear_fog_cloudy';
                break;
            case 'prevCloudy_heavyDZ_day':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_heavyDZ_night':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_heavyFZDZ_day':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_heavyFZDZ_night':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_heavyFZRA_day':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_heavyFZRA_night':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_heavyRA_day':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_heavyRA_night':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_heavySHGR_day':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_heavySHGR_night':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_heavySHRA_day':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_heavySHRA_night':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_heavyFG_day':
                return '0018_clear_fog_cloudy';
                break;
            case 'prevCloudy_heavyFG_night':
                return '0018_clear_fog_cloudy';
                break;
            case 'prevCloudy_heavyRASN_day':
                return '0006_sun_rain_snow';
                break;
            case 'prevCloudy_heavyRASN_night':
                return '0006_sun_rain_snow';
                break;
            case 'prevCloudy_heavySHRASN_day':
                return '0006_sun_rain_snow';
                break;
            case 'prevCloudy_heavySHRASN_night':
                return '0006_sun_rain_snow';
                break;
            case 'prevCloudy_heavySHSN_day':
                return '0004_clear_snow';
                break;
            case 'prevCloudy_heavySHSN_night':
                return '0004_clear_snow';
                break;
            case 'prevCloudy_heavySN_day':
                return '0004_clear_snow';
                break;
            case 'prevCloudy_heavySN_night':
                return '0004_clear_snow';
                break;
            case 'prevCloudy_heavyTS_day':
                return '0002_sun_thunderstorm';
                break;
            case 'prevCloudy_heavyTS_night':
                return '0002_sun_thunderstorm';
                break;
            case 'prevCloudy_lightTS_day':
                return '0002_sun_thunderstorm';
                break;
            case 'prevCloudy_lightTS_night':
                return '0002_sun_thunderstorm';
                break;
            case 'prevCloudy_modTS_day':
                return '0002_sun_thunderstorm';
                break;
            case 'prevCloudy_modTS_night':
                return '0002_sun_thunderstorm';
                break;
            case 'prevCloudy_TS_day':
                return '0002_sun_thunderstorm';
                break;
            case 'prevCloudy_TS_night':
                return '0002_sun_thunderstorm';
                break;
            case 'prevCloudy_heavyTSGR_day':
                return '0027_sun_hail_storm';
                break;
            case 'prevCloudy_heavyTSGR_night':
                return '0027_sun_hail_storm';
                break;
            case 'prevCloudy_heavyTSRA_day':
                return '0002_sun_thunderstorm';
                break;
            case 'prevCloudy_heavyTSRA_night':
                return '0002_sun_thunderstorm';
                break;
            case 'prevCloudy_heavyTSRASN_day':
                return '0006_sun_rain_snow';
                break;
            case 'prevCloudy_heavyTSRASN_night':
                return '0006_sun_rain_snow';
                break;
            case 'prevCloudy_heavyTSSN_day':
                return '0004_clear_snow';
                break;
            case 'prevCloudy_heavyTSSN_night':
                return '0004_clear_snow';
                break;
            case 'prevCloudy_lightDZ_day':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_lightDZ_night':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_lightFZDZ_day':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_lightFZDZ_night':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_lightFZRA_day':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_lightFZRA_night':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_lightRA_day':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_lightRA_night':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_lightSHGR_day':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_lightSHGR_night':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_lightSHRA_day':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_lightSHRA_night':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_lightFG_day':
                return '0019_clear_fog';
                break;
            case 'prevCloudy_lightFG_night':
                return '0019_clear_fog';
                break;
            case 'prevCloudy_lightRASN_day':
                return '0006_sun_rain_snow';
                break;
            case 'prevCloudy_lightRASN_night':
                return '0006_sun_rain_snow';
                break;
            case 'prevCloudy_lightSHRASN_day':
                return '0006_sun_rain_snow';
                break;
            case 'prevCloudy_lightSHRASN_night':
                return '0006_sun_rain_snow';
                break;
            case 'prevCloudy_lightSHSN_day':
                return '0004_clear_snow';
                break;
            case 'prevCloudy_lightSHSN_night':
                return '0004_clear_snow';
                break;
            case 'prevCloudy_lightSN_day':
                return '0004_clear_snow';
                break;
            case 'prevCloudy_lightSN_night':
                return '0004_clear_snow';
                break;
            case 'prevCloudy_lightTSGR_day':
                return '0027_sun_hail_storm';
                break;
            case 'prevCloudy_lightTSGR_night':
                return '0027_sun_hail_storm';
                break;
            case 'prevCloudy_lightTSRA_day':
                return '0002_sun_thunderstorm';
                break;
            case 'prevCloudy_lightTSRA_night':
                return '0002_sun_thunderstorm';
                break;
            case 'prevCloudy_lightTSRASN_day':
                return '0006_sun_rain_snow';
                break;
            case 'prevCloudy_lightTSRASN_night':
                return '0006_sun_rain_snow';
                break;
            case 'prevCloudy_lightTSSN_day':
                return '0004_clear_snow';
                break;
            case 'prevCloudy_lightTSSN_night':
                return '0004_clear_snow';
                break;
            case 'prevCloudy_DZ_day':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_DZ_night':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_FZDZ_day':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_FZDZ_night':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_FZRA_day':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_FZRA_night':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_modDZ_day':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_modDZ_night':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_modFZDZ_day':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_modFZDZ_night':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_modFZRA_day':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_modFZRA_night':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_modRA_day':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_modRA_night':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_modSHGR_day':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_modSHGR_night':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_modSHRA_day':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_modSHRA_night':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_RA_day':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_RA_night':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_SHGR_day':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_SHGR_night':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_SHRA_day':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_SHRA_night':
                return '0005_clear_showers';
                break;
            case 'prevCloudy_modRASN_day':
                return '0006_sun_rain_snow';
                break;
            case 'prevCloudy_modRASN_night':
                return '0006_sun_rain_snow';
                break;
            case 'prevCloudy_modSHRASN_day':
                return '0006_sun_rain_snow';
                break;
            case 'prevCloudy_modSHRASN_night':
                return '0006_sun_rain_snow';
                break;
            case 'prevCloudy_RASN_day':
                return '0006_sun_rain_snow';
                break;
            case 'prevCloudy_RASN_night':
                return '0006_sun_rain_snow';
                break;
            case 'prevCloudy_SHRASN_day':
                return '0006_sun_rain_snow';
                break;
            case 'prevCloudy_SHRASN_night':
                return '0006_sun_rain_snow';
                break;
            case 'prevCloudy_modSHSN_day':
                return '0004_clear_snow';
                break;
            case 'prevCloudy_modSHSN_night':
                return '0004_clear_snow';
                break;
            case 'prevCloudy_modSN_day':
                return '0004_clear_snow';
                break;
            case 'prevCloudy_modSN_night':
                return '0004_clear_snow';
                break;
            case 'prevCloudy_SHSN_day':
                return '0004_clear_snow';
                break;
            case 'prevCloudy_SHSN_night':
                return '0004_clear_snow';
                break;
            case 'prevCloudy_SN_day':
                return '0004_clear_snow';
                break;
            case 'prevCloudy_SN_night':
                return '0004_clear_snow';
                break;
            case 'prevCloudy_modTSGR_day':
                return '0027_sun_hail_storm';
                break;
            case 'prevCloudy_modTSGR_night':
                return '0027_sun_hail_storm';
                break;
            case 'prevCloudy_TSGR_day':
                return '0027_sun_hail_storm';
                break;
            case 'prevCloudy_TSGR_night':
                return '0027_sun_hail_storm';
                break;
            case 'prevCloudy_modTSRA_day':
                return '0002_sun_thunderstorm';
                break;
            case 'prevCloudy_modTSRA_night':
                return '0002_sun_thunderstorm';
                break;
            case 'prevCloudy_TSRA_day':
                return '0002_sun_thunderstorm';
                break;
            case 'prevCloudy_TSRA_night':
                return '0002_sun_thunderstorm';
                break;
            case 'prevCloudy_modTSRASN_day':
                return '0006_sun_rain_snow';
                break;
            case 'prevCloudy_modTSRASN_night':
                return '0006_sun_rain_snow';
                break;
            case 'prevCloudy_TSRASN_day':
                return '0006_sun_rain_snow';
                break;
            case 'prevCloudy_TSRASN_night':
                return '0006_sun_rain_snow';
                break;
            case 'prevCloudy_modTSSN_day':
                return '0004_clear_snow';
                break;
            case 'prevCloudy_modTSSN_night':
                return '0004_clear_snow';
                break;
            case 'prevCloudy_TSSN_day':
                return '0004_clear_snow';
                break;
            case 'prevCloudy_TSSN_night':
                return '0004_clear_snow';
                break;
            case 'heavyTS':
                return '0003_thunderstorm';
                break;
            case 'lightTS':
                return '0003_thunderstorm';
                break;
            case 'modTS':
                return '0003_thunderstorm';
                break;
            case 'TS':
                return '0003_thunderstorm';
                break;
            case 'modTSGR':
                return '0026_hail_storm';
                break;
            case 'TSGR':
                return '0026_hail_storm';
                break;
            case 'modTSRA':
                return '0003_thunderstorm';
                break;
            case 'TSRA':
                return '0003_thunderstorm';
                break;
            case 'modTSRASN':
                return '0023_rain_snow_storm';
                break;
            case 'TSRASN':
                return '0023_rain_snow_storm';
                break;
            case 'modTSSN':
                return '0022_snow_storm';
                break;
            case 'TSSN':
                return '0022_snow_storm';
                break;
        }
    }
}
export const iconConverter = new IconConverter();
